<template>
  <div id="renewable_energy_sources_ship">
    <div 
      class="renewable_energy_sources-item"
      v-if="receivedData"
    >
      <CastomGraphic
          :received-data="receivedData[0]"
          graph-type="bar"
          index-axis="y"
          :id="'renewable_energy_sources_consumption'"
          :aspect-ratio="1"
          :maintain-aspect-ratio="true"
          :stacked="false"
      />
    </div>
  </div>
</template>
<script>
import CMS from '@/model/cms'
import Service from '@/service/service.js'
import { mapGetters } from 'vuex'

export default {
  name: 'RenewableEnergySources',
  components: {
    CastomGraphic: () => import('@/components/graph/CastomGraphic.vue'),
  },

  data () {
    return {
      receivedData: null,
      blockId: 'renewable_energy_sources',
      cloneElementId: 'renewable_energy_sources_ship'
    }
  },

  mounted () {
    this.getGraphData()
    Service.elementClone(this.blockId, this.cloneElementId)
  },

  computed: {
    ...mapGetters({
      userToken: 'getUserToken'
    }),
  },

  methods: {
    getGraphData() {
      CMS.getGraph(this.userToken, '59').then((response) => {
        this.receivedData = response.data
      })
    }
  }
}
</script>
<style lang="scss" scoped>
  .production_of_electricity-item {
    margin-top: 40px;
  }
</style>